import Vue from 'vue'
import Vuex from 'vuex'
import locale from "./locale"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    privileges: {},
    admin_name: null,
    is_set_password: null,
    company_id: null
  },
  getters: {
    privileges(state, getters) {
			return state.privileges;
		},
    admin_name(state, getters) {
      if (state.admin_name == null) {
        state.admin_name = window.localStorage.getItem("admin_name");
      }
			return state.admin_name;
		},
    is_set_password(state, getters) {
      if (state.is_set_password == null) {
        state.is_set_password = window.localStorage.getItem("is_set_password");
      }
			return state.is_set_password;
		},
    company_id(state, getters) {
      if (state.company_id == null) {
        state.company_id = window.localStorage.getItem("company_id");
      }
			return state.company_id;
		},
  },
  mutations: {
  },
  actions: {
    setPrivileges({state}, privileges) {
			state.privileges = privileges;
		},
    get_string({state}, key) {
      if (locale[key]) {
        let str = locale[key][state.language];
        if (str != null && str != "") {
          return str;
        } else {
          return key;
        }
      }
    },
    setAdminName({state}, name) {
      state.admin_name = name;
      window.localStorage.setItem("admin_name", name);
    },
    setIsSetPassword({state}, is_set_password) {
      state.is_set_password = is_set_password;
      window.localStorage.setItem("is_set_password", is_set_password);
    },
    setCompany({state}, company_id) {
      state.company_id = company_id;
      window.localStorage.setItem("company_id", company_id);
    }
  },
  modules: {
    service: locale
  }
})
